<!-- <div class="loader-base"  *ngIf="loader"><div class="loader"  ></div></div> -->
<div class="loader-base"  *ngIf="loader"><div class="loader"  ></div></div>
<app-masterheader></app-masterheader>

<div class="wrapper">

	<app-sidebar></app-sidebar>

	<div id="content">

		<!-- <app-breadcrumb></app-breadcrumb> -->

		<div class="container-fluid">
			<div class="row">
				<div class="col-md-12">

					<div class="row">
						<div class="col-md-12">
							<div class="card">
								<div class="card-body">
									<h4 class="card-title">Feedback</h4>
									<div class="table-responsive">
									<table id="tableFeedback" class="table table-bordered" width="99%" datatable  [dtTrigger]="dtTrigger" [dtOptions]="dtOptions">
						              <thead>
						                <tr>
						                  <th width="6%">Sl. No.</th>
						                  <th width="13%">Name</th>
						                  <th width="9%">Contact No.</th>
						                  <th width="17%">Email ID</th>
                              <th>Date</th>
						                  <th>Feedback</th>
						                  <th width="5%">Action</th>
						                </tr>
						              </thead>
                          <tbody>
                              <tr *ngFor="let element of feedbacklist ; let i = index;">
                                <td>{{i+1}}</td>
                                <td>{{element.name}}</td>
                                <td>{{element.phoneNumber}}</td>
                                <td>{{element.emailId}}</td>
                                <td>{{ (element.updatedOn  !== 'null') ? (element.updatedOn | date:'dd-MM-yyyy')  : '' }} {{ (element.updatedOn  !== 'null') ? (element.updatedOn | date:'shortTime')  : '' }} </td>
                                <td>{{element.comments}}</td>
                                <td><button type="submit" class="btn btn-xs btn-success" *ngIf="element.status!=true"  (click)="achieved(element.id)"><i class="fa fa-check"></i></button>
                                	<span class="badge badge-pill badge-secondary"  *ngIf="element.status==true">Archived</span>
                                </td>
                              </tr>
                          </tbody>
						              <!-- <tbody>
						                <tr>
						                  <td>1</td>
						                  <td>Tarini Prasad Das</td>
						                  <td>9583109860</td>
						                  <td>tariniprasad11@gmail.com</td>
						                  <td>
						                  	Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur.
						                  </td>
						                  <td>
						                  	<button type="submit" class="btn btn-xs btn-success"><i class="fa fa-check"></i></button>
						                  </td>
						                </tr>
						                <tr>
						                  <td>2</td>
						                  <td>Amit Kumar Sarangi</td>
						                  <td>8879455124</td>
						                  <td>amitsarangi@gmail.com</td>
						                  <td>
						                  	Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.
						                  </td>
						                  <td>
						                  	<button type="submit" class="btn btn-xs btn-success"><i class="fa fa-check"></i></button>
						                  </td>
						                </tr>
						                <tr>
						                  <td>3</td>
						                  <td>Pallabi Priyambada</td>
						                  <td>7008451422</td>
						                  <td>pallabipriyambada@gmail.com</td>
						                  <td>
						                  	Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
						                  </td>
						                  <td>
						                  	<span class="badge badge-pill badge-secondary">Achieved</span>
						                  </td>
						                </tr>
						              </tbody> -->

						            </table>
						          </div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

	</div>

	<div id="footer">
		<app-masterfooter></app-masterfooter>
	</div>

</div>
